import { render, staticRenderFns } from "./LimitTransaction.vue?vue&type=template&id=7a6c0680&scoped=true&"
import script from "./LimitTransaction.vue?vue&type=script&lang=js&"
export * from "./LimitTransaction.vue?vue&type=script&lang=js&"
import style0 from "./LimitTransaction.vue?vue&type=style&index=0&id=7a6c0680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6c0680",
  null
  
)

export default component.exports